import { Typography } from '@mui/material';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { Input } from '../../Inputs/Input';
import { Select } from '../../Select';
import { IntervalType } from '../../../services/api.types';
import { eventRules } from '../EventRules';
import { WeekdaysForm } from '../WeekdaysForm';

export interface IntervalFormProps {
  foo?: string;
}

export const IntervalForm = ({}: IntervalFormProps): JSX.Element => {
  const form = useFormContext();
  const intervalType = form.watch('intervalType') as IntervalType;
  const showWeekdaysForm = intervalType === IntervalType.WEEKLY;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-2">
        <Typography
          className={clsx(
            {
              'text-mui-error':
                form.formState.errors.intervalNumber ||
                form.formState.errors.intervalType,
            },
            'mb-1 font-bold'
          )}
          whiteSpace="nowrap"
        >
          Repetir a cada:
        </Typography>

        <div className="w-full max-w-[100px]">
          <Input
            type="number"
            name="intervalNumber"
            rules={eventRules.intervalNumber}
          />
        </div>

        <div>
          <Select
            id="intervalType"
            size="small"
            color="secondary"
            label=""
            value={intervalType}
            onChange={(value) => form.setValue('intervalType', value)}
            options={[
              { value: IntervalType.DAILY, label: 'dia(s)' },
              { value: IntervalType.WEEKLY, label: 'semana(s)' },
              { value: IntervalType.MONTHLY, label: 'mês(es)' },
              { value: IntervalType.YEARLY, label: 'ano(s)' },
            ]}
          />
        </div>
      </div>

      {showWeekdaysForm && <WeekdaysForm />}
    </div>
  );
};
